<script lang="ts">
    import Checkbox from "../../widgets/Checkbox.svelte"
    import { _ } from "svelte-i18n"
    export let rule: PriceCalculationRule
    export let index: number
</script>

<style>
    .row {
        margin-top: 0.6rem;
    }
</style>

<div class="row" data-cy="ruleSurchargePercentRow">
    <div class="col-sm-3 mt-xs layout align-items-center no-padding-left">
        <Checkbox
            radio="{true}"
            checked="{rule.type === 'surcharge'}"
            label="{$_('components.pcalc.markupOnPurchasePrice')}"
            on:checked="{() => {
                rule.type = 'surcharge'
            }}"
        />
    </div>
    <div class="col-sm-3 mt-xs no-padding">
        <div class="inputholder has-append no-input-margin">
            <input
                disabled="{rule.type !== 'surcharge'}"
                class="with-label-size"
                type="number"
                step="0.01"
                min="0"
                placeholder="0"
                bind:value="{rule.surchargePercent}"
            />
            <div class="input-append">%</div>
        </div>
    </div>
</div>
<div class="row" data-cy="ruleDiscountPercentRow">
    <div class="col-sm-3 mt-xs layout align-items-center no-padding-left">
        <Checkbox
            radio="{true}"
            checked="{rule.type === 'discount'}"
            label="{$_('components.pcalc.discountOnRRP')}"
            on:checked="{() => {
                rule.type = 'discount'
            }}"
        />
    </div>
    <div class="col-sm-3 mt-xs no-padding">
        <div class="inputholder hasLabel has-append no-input-margin">
            <input
                disabled="{rule.type !== 'discount'}"
                class="with-label-size"
                type="number"
                step="0.01"
                min="0"
                bind:value="{rule.discountPercent}"
            />
            <div class="input-append">%</div>
        </div>
    </div>
    <div class="col-sm-6 mt-xs no-padding-right">
        <div class="inputholder haslabel has-append no-input-margin">
            <label for="surchargePercent-{index}">{$_("components.pcalc.minMarginOnPurchasePrice")}</label>
            <input
                disabled="{rule.type !== 'discount'}"
                id="surchargePercent-{index}"
                type="number"
                step="0.01"
                min="0"
                placeholder="0"
                bind:value="{rule.surchargePercent}"
            />
            <div class="input-append">%</div>
        </div>
    </div>
</div>
